define('view/controller/booking/datetime/classes/TimeClassesServiceListView',['require','marionette','view/controller/booking/datetime/classes/TimeClassesServiceItemView','lib/view/UnwrapBehavior'],function (require) {

    var Marionette = require('marionette');
    var TimeClassesServiceItemView = require('view/controller/booking/datetime/classes/TimeClassesServiceItemView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    /**
     * Services list view for classes timeline
     *
     * @class TimeClassesServiceListView
     */
    return Marionette.CompositeView.extend({

        template: '#time_classes_service_list_view',
        childView: TimeClassesServiceItemView,
        childViewContainer: '#sb_time_classes_service_container',
        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        }

    });

});
